import { Link } from '@ipfabric/ui-components/Link/Link';
import {
  type TableColumnFormatHostname,
  getValueFromKeyOfType,
} from '@ipfabric/utils';
import type { RenderedTableCell } from 'components/Table/cells/RenderedTableCell';
import type { RenderCellContentArguments } from '../model/TableCellContentRenderFunction';

export const renderHostnameCell = <TRow,>(
  format: TableColumnFormatHostname<TRow>,
  { row, context, severity }: RenderCellContentArguments<TRow>,
): RenderedTableCell => {
  const hostname = getValueFromKeyOfType(row, format.field);
  const sn = getValueFromKeyOfType(row, format.snField);
  const content =
    !hostname ||
    !sn ||
    sn === 'unknown' ||
    !context.onOpenExplorer ||
    context.disableLinks ? (
      hostname
    ) : (
      <Link
        accent={severity === null ? 'positive' : 'contrast'}
        renderAs='button'
        onClick={() => {
          context.onOpenExplorer!(row, {
            sources: [{ hostname, kind: 'device', sn }],
          });
        }}
      >
        {hostname}
      </Link>
    );

  return {
    content,
  };
};
